module.exports = __webpack_public_path__ + "608676d32670ccdae0053f859d45097b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/bg/CL012-001.jpg
// module id = 95
// module chunks = 0